import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "text-center mb-4" }
const _hoisted_3 = {
  filter: "name",
  sort: "name"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { colspan: "99" }
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = { class: "d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        localizedKey: "Seleziona le offerte che il cliente deve aver acquistato per poter vedere l'offerta",
        text: "Seleziona le offerte che il cliente deve aver acquistato per poter vedere l'offerta"
      })
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      items: _ctx.offerte
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_localized_text, {
                localizedKey: "Nome",
                text: "Nome"
              })
            ]),
            _hoisted_4
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                _createElementVNode("td", _hoisted_6, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opData.items, (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(item.name), 1),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.local) = $event)),
                  value: item.identifier,
                  class: "checkBig form-control"
                }, null, 8, _hoisted_7), [
                  [_vModelCheckbox, _ctx.local]
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["items"]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-danger",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.annulla && _ctx.annulla(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Annulla modifiche e chiudi",
          text: "Annulla modifiche e chiudi"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-success",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ok && _ctx.ok(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Ok e chiudi",
          text: "Ok e chiudi"
        })
      ])
    ])
  ]))
}